export default __webpack_public_path__ + "static/media/filled-circle.8deb3763.svg";